import { enUSMessages } from "./en-US";
import { esESMessages } from "./es-ES";
import { ptBRMessages } from "./pt-BR";

export const allMessages = {
  "pt-BR": ptBRMessages,
  "en-US": enUSMessages,
  "es-ES": esESMessages,
} as const;

export type MessageCatalog = typeof ptBRMessages;

export function getMessages(locale: keyof typeof allMessages) {
  return allMessages[locale];
}
